/* import __COLOCATED_TEMPLATE__ from './driver-performance-panel.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';

export default class DriverPerformancePanel extends Component {
    @service tabService;

    tagName = '';

    updateAppData = () => {};
}
